import { HStack } from '@pets-ui/HStack/HStack'
import { SuccessFilled, CircleFilled } from '@pets-ui/icons'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

interface InputVerifyProps {
  success: boolean
  rule: string
}

export function InputVerify(props: InputVerifyProps) {
  const { success, rule } = props
  return (
    <HStack gap={1}>
      <SvgIcon color={success ? colors.green600 : colors.grey300}>
        {success ? <SuccessFilled /> : <CircleFilled />}
      </SvgIcon>
      <Text variant="caption" color={colors.grey600}>{rule}</Text>
    </HStack>
  )
}
